import { useCallback } from "react";
import { Link } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import useAuthorized from "hooks/useAuthorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import EmailUrlService from "services/EmailUrls";
import {
  invalidateEmailUrlsTableQuery,
  useEmailUrlsTable,
} from "hooks/useEmailUrlsTable";

export const EMAIL_URLS_PATH = "/settings/email_urls";

export const EMAIL_URLS_TABLE_CONSTANTS = {
  tableName: "email_urls",
  queryKey: "email_url",
  className: "EmailUrl",
  exportTableName: "EmailUrlsTable",
  header: "Email URLs",
  headerIcon: Link,
};

const EmailUrlsTableV3 = () => {
  const enableTags = useAuthorized(
    [
      ACL_RELATIONSHIPS.emailUrlTags.create,
      ACL_RELATIONSHIPS.emailUrlTags.read,
      ACL_RELATIONSHIPS.emailUrlTags.delete,
    ],
    { partialMatch: true }
  );
  const { filters, columns } = useEmailUrlsTable({
    className: EMAIL_URLS_TABLE_CONSTANTS.className,
    tableName: EMAIL_URLS_TABLE_CONSTANTS.tableName,
  });

  const fetchEmailUrls = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await EmailUrlService.getEmailUrlsTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching email URLs:", error);
        throw error;
      }
    },
    [columns]
  );

  const createButton = (
    <TableCreateButton
      permissions={[ACL_RELATIONSHIPS.emailUrl.create]}
      to={`${EMAIL_URLS_PATH}/new`}
    >
      New Email URL
    </TableCreateButton>
  );

  return (
    <BaseTableV3
      columns={columns}
      fetchData={fetchEmailUrls}
      headerIcon={EMAIL_URLS_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_URLS_TABLE_CONSTANTS.header}
      createButton={createButton}
      queryKey={EMAIL_URLS_TABLE_CONSTANTS.queryKey}
      tagsDropdownParams={{ visible: enableTags }}
      tableName={EMAIL_URLS_TABLE_CONSTANTS.tableName}
      filters={filters}
      className={EMAIL_URLS_TABLE_CONSTANTS.className}
      invalidateData={invalidateEmailUrlsTableQuery}
      enableSettings
      enableSearch
    />
  );
};

export default EmailUrlsTableV3;
